/**
 * ---------------------------------------------------------------------
 * veu frontend visitor routes
 * ---------------------------------------------------------------------
 * @author seven-m.de
 * @copyright SEVEN M 2020
 *
 * Handles Routes.
 *
 * Only Routes are rendered and components are loaded
 * where the user has access.
 */
/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */
import React, { Component } from 'react';
import { withRouter, Redirect } from "react-router-dom";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

/*
 * ---------------------------------------------------------------------
 * import action
 * ---------------------------------------------------------------------
 */
import {
    redirectTo,
    clearRedirect,
} from 'src/shared_modules/veu-visitors-core/actions/system';

/*
 * ---------------------------------------------------------------------
 * Component AppRedirect
 * ---------------------------------------------------------------------
 */
class AppRedirect extends Component {

    constructor(props) {
        super(props);
        // local internal component state
        this.state = {
            isLoading : true,
            error : null,
        };
    }

    componentDidMount() {
        // failsave
        if( !this.props.system.startloc )
            return;

        let { event } = this.props.match.params;
        let { pathname } = this.props.location;

        pathname = pathname.replace(/\//g,"");
        let startloc = this.props.event.path + this.props.system.startloc.path;

        if( pathname === event || pathname === ("visitor" + event) ) {
            // this is illigal so we need to redirect to Home
            this.props.redirectTo(startloc);
        }

        // Maybe we find a better solution, but this fixes the schaeffler sso auth problem
        if( !pathname.endsWith("authschaeffler") && !pathname.endsWith("authlinkedin") )
            this.handleOnAirRedirect(pathname);

        this.setState({isLoading: false});
    }

    componentDidUpdate(prevProps) {

        let redirectpath = this.props.system.redirectPath;
        let { event } = this.props.match.params;
        let { pathname } = this.props.location;

        //console.error("componentDidUpdate - this.props: " + JSON.stringify(this.props));

        if( redirectpath !== null && redirectpath === pathname ) {
            this.props.clearRedirect();
            return;
        }

        //IsStagingBasePorject
        if(redirectpath !== null &&  !redirectpath.includes("stageview") )
          if(this.props.event.isStagingBase){
              let stageview = this.props.event.path + "/stageview/";
              this.props.redirectTo(stageview);
              return;
          }


        //Minievent
        if(redirectpath !== null &&  !redirectpath.includes("tilesmenu") ) {
            if( this.props.event.isMiniEvent ){
                if( this.props.user && (this.props.event.hasProtectionPin && !this.props.user.minieventsLoggedIn.includes(this.props.event.path)) ) {
                    this.props.redirectTo(this.props.event.path + "/home");
                }
                else {
                    let tilesmenu = this.props.event.path + "/tilesmenu/";
                    this.props.redirectTo(tilesmenu);
                }
                return;
            }
        }

        // failsave
        if( !this.props.system.startloc )
            return;

        pathname = pathname.replace(/\//g,"");

        if( pathname === event || pathname === ("visitor" + event)  )
        {
            let startloc = this.props.event.path + this.props.system.startloc.path;
            console.debug("ROUTER startloc: " + startloc );

            // this is illigal so we need to redirect to Home
            if (this.props.user && (this.props.event.hasProtectionPin && !this.props.user.minieventsLoggedIn.includes(this.props.event.path))) {
                this.props.redirectTo(this.props.event.path + "/home");
            }
            else {
                this.props.redirectTo(startloc);
            }
            return;
        }
        //this.handleOnAirRedirect(pathname);

    }

    handleOnAirRedirect(pathname) {
        // check if not on air or preregister is enabled

        if( !pathname.endsWith("home") ) {
            // Location and content access levels are handled inside their components
            if ( (!this.props.event.onAir && !this.props.event.enablePreregister) ||
                 (this.props.user && (this.props.event.hasProtectionPin && !this.props.user.minieventsLoggedIn.includes(this.props.event.path)))) {
                //case 1 - redirect to home if event is no longer onAir or event is protected by pin
                this.props.redirectTo(this.props.event.path + "/home");
            }
        }
        if( !pathname.endsWith("preregister") ) {
            // Location and content access levels are handled inside their components
            if ( this.props.event.enablePreregister ) {
                //case 2 - redirect to preregister
                this.props.redirectTo(this.props.event.path + "/preregister");
            }
        }
    }

    render() {
        if( this.state.isLoading )
            return( null );

        let redirectpath = this.props.system.redirectPath;
        const {pathname} = this.props.location;

        // execute redirect from store
        if( redirectpath !== null && redirectpath !== pathname)
        {
            //  console.warn(`redirecting now -- from: ${pathname} -- to : ${redirectpath}` )
            return (<Redirect exact to={{ pathname: redirectpath }} />);
        }



        return (null);
    }
}

AppRedirect.propTypes = {
    system : PropTypes.object,
    user : PropTypes.object,
    event : PropTypes.object,
};
/*
 * ---------------------------------------------------------------------
 * AppRoutes Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        system : state.system,
        user : state.user,
        event : state.event,
     };
};

const mapDispatchToProps = {
    redirectTo,
    clearRedirect
}


/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withRouter(AppRedirect));
